import { StudentBalancesTable } from "@/components/events/StudentBalancesTable";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";

const StudentEventBalancesPage = () => {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AdminSidebar />
        <SidebarInset>
          <div className="container max-w-6xl mx-auto px-4 py-6">
            <h1 className="text-2xl font-bold mb-4">คงเหลือ Event ของนักเรียน</h1>
            <StudentBalancesTable />
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default StudentEventBalancesPage;
